var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4893 24.969C18.3905 26.0691 19.3467 26.9363 20.4506 26.8978L20.7573 26.8871C21.8611 26.8485 22.6604 25.8983 22.9636 24.8362C23.2885 23.6977 24.0007 22.7946 25.2035 22.013C27.2832 20.6782 28.6104 18.9604 28.5172 16.2916C28.3784 12.3167 25.0949 10.1118 20.5863 10.2693C17.1306 10.3899 14.2624 12.0082 13.4583 15.2064C13.1847 16.2947 14.1567 17.2024 15.2782 17.1633L15.941 17.1401C17.0163 17.1026 17.7864 16.1261 18.4287 15.2629C18.9576 14.552 19.8011 14.1627 20.6984 14.1313C22.2316 14.0778 23.5051 15.0567 23.5603 16.6353C23.6122 18.123 22.5678 19.1487 21.2019 20.0833C19.3404 21.3507 18.6655 23.0086 18.4893 24.969ZM20.9429 34.1577C22.3966 34.107 23.6147 32.8478 23.5734 31.3369C23.51 29.8496 22.207 28.6785 20.7534 28.7292C19.2543 28.7816 18.0588 30.04 18.1221 31.5273C18.1635 33.0381 19.4438 34.2101 20.9429 34.1577Z",
    fill: "#854CC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.13ee08ccf70f652b3700528b7e8514f3.svg";
export { ForwardRef as ReactComponent };